import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LinkSectionComponent } from './link-section/link-section.component';

@NgModule({
  declarations: [],
  exports: [LinkSectionComponent],
  imports: [CommonModule, FontAwesomeModule, QueryParamModule, LinkSectionComponent],
})
export class LinkSectionModule {}
